import React, { useEffect, useState } from "react";
import AuthCard from "../../shared/components/CustomCards";
import { CustomPassword } from "../../shared/components/AllInputs";
import PrimaryButton from "../../shared/components/CustomButtons";
import { useLocation, useNavigate } from "react-router-dom";
import formValidation from "../../utils/validations";
import { showFormErrors } from "../../utils/commonFunctions";
import { useDispatch } from "react-redux";
import { resetPasswordAction } from "../../store/actions/auth.actions";

export default function CreateNewPassword() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const userData = location.state;
  const [loading, setLoading] = useState(false);

  const [data, setData] = useState({
    email: userData.email,
    password: "",
    confirmPassword: "",
  });

  useEffect(() => {
    if (!userData) navigate("/auth/login");
  }, [navigate, userData]);

  const handleChange = ({ name, value }) => {
    const formErrors = formValidation(name, value, data);
    setData((prev) => ({ ...prev, [name]: value, formErrors }));
  };

  const resetPassword = () => {
    if (showFormErrors(data, setData)) {
      dispatch(resetPasswordAction(data, setLoading, navigate));
    }
  };

  return (
    <div className="flex justify-content-center align-items-center h-full">
      <AuthCard heading={"Create new password"}>
        <CustomPassword
          label={"New password"}
          name="password"
          placeholder="New password"
          col={12}
          data={data}
          onChange={handleChange}
        />
        <CustomPassword
          label={"Confirm new password"}
          name="confirmPassword"
          placeholder="Confirm new password"
          col={12}
          data={data}
          onChange={handleChange}
        />
        <PrimaryButton
          label="Continue"
          extraClassNames="mt-3"
          onClick={resetPassword}
          loading={loading}
        />
      </AuthCard>
    </div>
  );
}
